import { Link } from 'react-router-dom';
import { BrandLogo } from '@/components/BrandLogo.js';
import { LoginBackgroundSlideshow } from '@/components/auth/LoginBackgroundSlideshow.js';

type PublicAuthShellProps = {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  backTo?: string;
  backLabel?: string;
};

export function PublicAuthShell({
  children,
  title,
  subtitle,
  backTo = '/login',
  backLabel = 'Voltar ao login',
}: PublicAuthShellProps) {
  return (
    <div className="relative min-h-screen">
      <LoginBackgroundSlideshow />

      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-6 py-12">
        <div className="w-full max-w-[400px]">
          <div className="mb-8 flex flex-col items-center">
            <Link to="/" style={{ display: 'inline-block', lineHeight: 0 }}>
              <BrandLogo height={48} linkTo={null} />
            </Link>
            {title ? (
              <h1
                className="mt-6 text-center text-xl font-semibold"
                style={{ fontFamily: 'var(--font-heading)', color: 'var(--text)' }}
              >
                {title}
              </h1>
            ) : null}
            {subtitle ? (
              <p className="mt-2 text-center text-[13px]" style={{ color: 'var(--text2)' }}>
                {subtitle}
              </p>
            ) : null}
          </div>

          {children}

          <p className="mt-8 text-center text-[12px]" style={{ color: 'var(--text3)' }}>
            <Link to={backTo} className="underline hover:opacity-80">
              {backLabel}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
